import { LinearProgress } from '@mui/joy';

import { ChartsGrid } from '@/Pages/SingleDashboard/ChartsGrid';
import { useChartTimeFilter } from '@/Pages/SingleDashboard/hooks/useChartTimeFilter';
import { useSeriesColorsMap } from '@/Pages/SingleDashboard/utils/getSeriesColor';
import { DateTimeRangePicker } from '@/components/DateTimeRangePicker/DateTimeRangePicker';
import { useHostProjectMetrics } from '@/hooks/useSwr';

const LGP_METRICS_CHARTS_DEFAULT_STEP = '1m';
const LGP_METRICS_CHARTS_DEFAULT_DURATION = '15m';

export const MonitoringPanel = ({
  hostProjectId,
}: {
  hostProjectId: string;
}) => {
  const timeFilter = useChartTimeFilter({
    timeRange: { duration: LGP_METRICS_CHARTS_DEFAULT_DURATION },
  });
  const {
    data: metrics,
    isLoading,
    error,
  } = useHostProjectMetrics(
    hostProjectId,
    {
      start_time: timeFilter.customChartsParams.start_time,
      end_time: timeFilter.customChartsParams.end_time,
      step: timeFilter.customChartsParams.stride.minutes
        ? `${timeFilter.customChartsParams.stride.minutes}m`
        : LGP_METRICS_CHARTS_DEFAULT_STEP,
    },
    { revalidateOnFocus: false }
  );

  const seriesColorsMap = useSeriesColorsMap({
    dashboard: {
      sub_sections: [],
      charts: metrics?.charts ?? [],
    },
    isPrebuilt: false,
  });

  if (!metrics && !error) {
    return (
      <div>
        <LinearProgress />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-4">
      <div className="px-4">
        <DateTimeRangePicker
          value={timeFilter.timeModel}
          onChange={timeFilter.setTimeModel}
          align="start"
          hideAllTime
        />
      </div>
      <ChartsGrid
        dashboardId={hostProjectId}
        sub_sections={metrics?.sub_sections ?? []}
        charts={metrics?.charts ?? []}
        isLoading={isLoading}
        error={error}
        seriesColorsMap={seriesColorsMap}
        timeFilter={timeFilter}
        customChartMargins={{ left: 55 }}
        hideExpandedView
        readOnly
        hideLegendForSingleSeriesCharts
        isPrebuilt
      />
    </div>
  );
};
